import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProductTemplate from '../components/products/ProductTemplate';
import BookingConfirmationPage from '../pages/BookingConfirmationPage';
import CairnsTours from '../pages/CairnsTours';
import Contact from '../pages/Contact';
import Faq from '../pages/Faq';
import FleetPage from '../pages/FleetPage';
import HelicopterTours from '../pages/HelicopterTours';
import Homepage from '../pages/Homepage';
import PageNotFound from '../pages/PageNotFound';
import TermsAndConditions from '../pages/TermsAndConditions';

export enum PATH_IDS {
    PRODUCT_NAME = 'productName',
    PRODUCT_LOCATION = 'productLocation',
    BOOKING_REF = 'ref',
}

export const routes = {
    products: (productLocation: string, productName: string) => `/${productLocation}/${productName}`,
    confirmation: (ref: string) => `/confirmation/${ref}`,
};

export default function Pages() {
    return (
        <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/contactus" element={<Contact />} />
            <Route path="/termsandconditions" element={<TermsAndConditions />} />
            <Route path="/fleet" element={<FleetPage />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/cairns/helicopter-tours" element={<HelicopterTours />} />
            <Route path="/cairns" element={<CairnsTours />} />
            <Route path={routes.confirmation(`:${PATH_IDS.BOOKING_REF}`)} element={<BookingConfirmationPage />} />
            <Route
                path={routes.products(`:${PATH_IDS.PRODUCT_LOCATION}`, `:${PATH_IDS.PRODUCT_NAME}`)}
                element={<ProductTemplate />}
            />
            <Route path="/404" element={<PageNotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
    );
}
